/* eslint-disable react/prop-types */
import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import InfiniteScroll from "react-infinite-scroll-component";
import PersonOfBusinessTable from "./PersonOfBusinessTable";
import Loading from "../../../../components/Loading";
import ModalUi from "../../../../components/ModalUI";
import {getPersonOfBusiness} from "../../../../api/routes";
import queryString from "../../../../functions/queryString";


export default function PersonOfBusinessModal({modalInfo, closeModal}) {
    const [loading, setLoading] = useState(false);
    const [cursor, setCursor] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [personOfBusiness, setPersonOfBusiness] = useState([]);

    useEffect(() => {
        if (modalInfo?.businessId) {
            setLoading(true);
            const query = {
                cursor: cursor === null ? null : cursor,
            }
            getPersonOfBusiness(modalInfo?.businessId, queryString(query), (isOk, data) => {
                if (!isOk) {
                    setLoading(false);
                    return toast.error(data.message)
                } else {
                    if (page !== 0) {
                        setPersonOfBusiness((prev) => ([...prev, ...data.data]));
                    } else {
                        setPersonOfBusiness(data.data);
                    }
                    setLoading(false);
                    setCursor(data.meta.next_cursor === null ? '' : data.meta.next_cursor);
                    if (data.meta.next_cursor !== null)
                        return setHasMore(true);

                    else return setHasMore(false)
                }
            })
        }
    }, [page, modalInfo?.businessId]);
    const fetchMoreData = () => {
        if (loading) return;
        if (hasMore) {
            setPage(prevPage => prevPage + 1)
        }
    }
    return (
        <ModalUi open={modalInfo.state} handleClose={closeModal}>
            <Loading loading={loading}/>
            {personOfBusiness.length > 0 ?
                <InfiniteScroll dataLength={personOfBusiness.length} next={fetchMoreData} hasMore={hasMore}>
                    <PersonOfBusinessTable data={personOfBusiness}/>
                </InfiniteScroll> : <p style={{fontSize: 16}}>اطلاعاتی ثبت نشده است!</p>}
        </ModalUi>
    )
}
